import React from 'react';

const StaticPropertySection = ({ children }) => {
  const originalSlides = React.Children.toArray(children);

  return (
    <div className="property-carousel">
      <div className="carousel-track-container">
        <div
          className="carousel-track"
        >
          {/* Map over and render each child slide */}
          {originalSlides.map((slide, index) => (
            <div className="carousel-slide" key={index}>
              {slide}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default StaticPropertySection;